import { Permission } from '@traton/devportal-rbac-common-lib';

export const portalgroupsReadPermission: Permission = {
  name: 'portalgroups.read',
  description: 'Allows reading portal groups',
  type: 'basic',
  attributes: { action: 'read' },
};
export const portalgroupsCreatePermission: Permission = {
  name: 'portalgroups.create',
  description: 'Allows creating portal groups',
  type: 'basic',
  attributes: { action: 'create' },
};
export const portalgroupsUpdatePermission: Permission = {
  name: 'portalgroups.update',
  description: 'Allows updating portal groups',
  type: 'basic',
  attributes: { action: 'update' },
};
export const portalgroupsDeletePermission: Permission = {
  name: 'portalgroups.delete',
  description: 'Allows deleting portal groups',
  type: 'basic',
  attributes: { action: 'delete' },
};

export const portalgroupsPermissions = [
  portalgroupsReadPermission,
  portalgroupsCreatePermission,
  portalgroupsUpdatePermission,
  portalgroupsDeletePermission,
];
